// extracted by mini-css-extract-plugin
export default {"input":"InputTextAdmin_input__mM590"};